import Skeleton from "@mui/material/Skeleton";

const CommonSkeleton = ({
  variant,
  height,
  width,
  color,
  sx,
  className,
  borderRadius,
}) => {
  return (
    <Skeleton
      variant={variant || "text"}
      animation="wave"
      height={height || 24}
      width={width || 140}
      sx={{
        backgroundColor: `${color || ""} !important`,
        borderRadius: borderRadius || "120px",
        ...sx,
      }}
      className={className}
    />
  );
};

export default CommonSkeleton;
